/** Функция для получения разрешения на использование микрофона / камеры */
export function getDevicePermission(constraints: MediaStreamConstraints) {
    return navigator.mediaDevices.getUserMedia(constraints);
}
